import React, { useEffect } from 'react';
import { Trans } from 'react-i18next';

import 'leaflet/dist/leaflet.css';
import Navbar from '../../../Navbar';

import { useGeolocationContext } from './hooks/geolocationContext';

import { VehiclesGeolocationList } from './VehiclesGeolocationList';
import { GeolocationMap } from './GeolocationMap';

const Geolocation = ({ history, match, location }) => {
	const { vehicles, getGeolocationData, refreshTimeInSeconds } = useGeolocationContext();

	const timeToRefresh = refreshTimeInSeconds * 1000;

	useEffect(() => {
		getGeolocationData(true);
	}, []);

	// Refresh geolocation data every X seconds
	useEffect(() => {
		const interval = setInterval(() => {
			getGeolocationData();
		}, timeToRefresh);

		return () => clearInterval(interval);
	}, [vehicles]);

	return (
		<div className="bkg-white-dark listviewnew medialist">
			<Navbar history={history} match={match} location={location} />
			<div className="titlebar">
				<div className="titlebar-left">
					<div className="left">
						<h1>
							<Trans>GPS Location</Trans>
						</h1>
					</div>
				</div>
				{/* <div className="titlebar-right">
					<div className="right">
						<div className="button primary px-32" onClick={() => console.log('Add Device')} style={{display: 'flex', flexDirection: 'row', alignItems: 'center', paddingRight: 15}}>
							<Trans>Add Device</Trans>
						</div>
					</div>
				</div> */}
			</div>
			<div className="geolocation-page">
				<VehiclesGeolocationList />

				<GeolocationMap />
			</div>
		</div>
	)
}

export default Geolocation;